import { forwardPropsToState } from '../../../utils/react_utils';

const RealizeInputPassword = window.InputPassword;

@forwardPropsToState([{prop: 'value'}])
export default class InputPassword extends RealizeInputPassword {}
